<template>
  <div>
    <inputs :title="title" :type="type" :show-fabric-rolls="true"/>
  </div>
</template>

<script>
import Inputs from "./components/Inputs";
export default {
  components: {
    Inputs,
  },
  data() {
    return {
      title: "Scan Fabric For Stock Correction",
      type: "stock_correction",
    };
  },
};
</script>
